import { motion, useScroll, useTransform } from 'framer-motion';
import { useRef } from 'react';

const Hero = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['start start', 'end start'],
  });

  const y = useTransform(scrollYProgress, [0, 1], [0, 300]);
  const opacity = useTransform(scrollYProgress, [0, 0.5], [1, 0]);

  return (
    <section ref={ref} className="relative h-screen overflow-hidden">
      <motion.div
        style={{ y }}
        className="absolute inset-0 w-full h-full"
      >
        <img
          src="https://images.pexels.com/photos/756493/pexels-photo-756493.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
          alt="Cabana no meio da natureza"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-background" />
      </motion.div>

      <motion.div
        style={{ opacity }}
        className="relative h-full flex flex-col items-center justify-center px-6 text-center"
      >
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
          className="text-xs tracking-[0.2em] uppercase font-bold text-accent mb-6"
        >
          Barra de Guaratiba, Rio de Janeiro
        </motion.p>
        
        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.5 }}
          className="text-5xl md:text-7xl font-light tracking-tight leading-[1.1] text-white max-w-4xl mb-8"
        >
          Um Refúgio na Floresta
        </motion.h1>
        
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.7 }}
          className="text-lg md:text-xl leading-relaxed text-white/90 max-w-2xl mb-12"
        >
          Cabanas de vidro com piscinas privativas aquecidas, cercadas pela mata atlântica.
          Uma experiência única para casais que buscam desconectar.
        </motion.p>
        
        <motion.button
          data-testid="hero-booking-btn"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.9 }}
          onClick={() => document.getElementById('booking')?.scrollIntoView({ behavior: 'smooth' })}
          className="bg-accent text-white hover:bg-accent/90 rounded-full px-8 py-6 text-sm uppercase tracking-widest transition-all hover:scale-105"
        >
          Solicitar Reserva
        </motion.button>
      </motion.div>
    </section>
  );
};

export default Hero;